<template>
    <v-container fluid align-start ma-0 pa-2 class="container-height">
        <v-row no-gutters fill-height>
            <v-col cols="12">
                <i-card-vertical :headerTitle="menuTitle" :useBtnList="[
                    'btnRetrieve', //Retrieve
                    'btnExcel'
                ]" @btnRetrieve="btnRetrieve()" @btnExcel="onExporting()">
                                        <template v-slot:body>
                                            <v-layout column overflow-auto>
                                                <v-row dense>
                                                    <v-col cols="12" class="pa-0">
                                                        <i-card-top class="d-md-flex" outlined>
                                                            <template v-slot:body>
                                        <v-layout column>
                                            <v-row no-gutters class="center pa-2 pb-0">
                                            <v-icon small color="blue" class="pl-2 pb-0">mdi-circle</v-icon>
                                                <span class="pa-1 pt-2 subTitle">Division : </span>
                                                <v-col cols="2">
                                                    <v-select v-model="division.select" :items="division.items" item-text="name" item-value="cd" return-object single-line
                                                        outlined dense @change="changeDiv()"/>
                                                </v-col>
                                            <i-label :label="'Period : '" v-if="visDiv === true"/>
                                            <v-col cols="1" v-if="visDiv === true">
                                                <DxDateBox
                                                :value="startDate"
                                                height="30px"
                                                display-format="yyyy-MM-dd"
                                                :acceptCustomValue="false"
                                                @value-changed="e => {reqDtFrom = e.value && getStrFormat(e.value)}"
                                                />
                                            </v-col>
                                            <span class="pa-1 subTitle" v-if="visDiv === true"> ~ </span>
                                            <v-col cols="1" v-if="visDiv === true">
                                                <DxDateBox
                                                :value="endDate"
                                                height="30px"
                                                display-format="yyyy-MM-dd"
                                                :acceptCustomValue="false"
                                                @value-changed="e => {reqDtFrom = e.value && getEndFormat(e.value)}"
                                                />
                                            </v-col>
                                            <i-label :label="'Ship No : '" class="pl-2" v-if="visDiv === false"/>
                                            <v-col cols="1" v-if="visDiv === false">
                                                <v-select
                                                v-model=" shipNo"
                                                :items="shipNoList"
                                                single-line
                                                outlined
                                                dense
                                                height="32"                 
                                                />
                                            </v-col>
                                            <v-checkbox
                                                v-model="expCarry"
                                                label= "Except Carried Out"
                                                class="pl-5"
                                            ></v-checkbox>
                                            
                                            <v-checkbox
                                                v-model="expDely"
                                                label= "Except Delivered"
                                                class="pl-5"
                                            ></v-checkbox>

                                            </v-row>
                                        </v-layout>
                                        </template>
                                    </i-card-top>
                                </v-col>
                            </v-row>
                            <v-row no-gutters>
                                <v-col cols="12" class="pa-0">
                                    <DxDataGrid id="epmsa014" class="listBox" :ref="epmsa014Ref"
                                        :data-source="gridMainList" :remote-operations="false"
                                        :hover-state-enabled="true" :allow-column-resizing="true"
                                        :allow-column-reordering="true" :row-alternation-enabled="true"
                                        :show-borders="true" :width="grid.width" :show-row-lines="true" key-expr="id"
                                        :focused-row-enabled="true" :column-hiding-enabled="false"
                                        :selection="{ mode: 'none' }" :sorting="{ mode: 'multiple' }"
                                        :word-wrap-enabled="true"    
                                        @exporting="onExporting"                                    
                                        >
                                        <DxExport :enabled="true" />
                                        <DxHeaderFilter :visible="true"/>
                                        <DxColumn data-field="id" caption="No" width="5%" data-type="string" 
                                                  :allow-editing="false" alignment="center"  :allow-header-filtering="false"/>                                                                            
                                                                                                                     
                                        <DxColumn caption="SECTION USING MANAGEMENT" width="70%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn data-field="shipNo" caption="SHIP" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="true" />
                                                <DxColumn data-field="block" caption="BLOCK" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="true"/>
                                                <DxColumn data-field="cutGrp" caption="GROUP" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="true"/>
                                                <DxColumn data-field="lotNo" caption="LOT" width="10%"
                                                data-type="string" :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="true"/>
                                                <DxColumn data-field="useQty" caption="Q'TY" width="10%"
                                                data-type="number" format = "#,###"  :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="false"/>
                                                <DxColumn data-field="useWgt" caption="Weight" width="15%" data-type="number" format = "#,###" 
                                                          :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="false"/>
                                                <DxColumn data-field="midCutDay" caption="Mid.PSD" width="15%"
                                                data-type="string" :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="true"/>
                                                <DxColumn data-field="whDte" caption="WH.Dte" width="15%"
                                                data-type="string" :allow-editing="false" alignment="center" :visible="true"  :allow-header-filtering="false"/>
                                        </DxColumn>
                                        
                                        <DxColumn data-field="woQty" caption="W/O Qty" width="10%" data-type="number" format = "#,###"  :allow-editing="false" alignment="center"
                                                    :visible="true" header-cell-template="woQty" :allow-header-filtering="false"/>
                                        
                                        <template #woQty>
                                            <div>WORK <br> ORDER <br> Q'TY</div>
                                        </template>

                                        <DxColumn caption="REQUEST" width="40%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true" :allow-header-filtering="false">
                                            <DxColumn data-field="reqDte" caption="DATE" width="15%" data-type="string" 
                                                      :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="true"/>
                                            <DxColumn data-field="reqQty" caption="Q'ty" width="10%" data-type="number" format = "#,###" 
                                                      :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>
                                            <DxColumn data-field="reqWgt" caption="Weight" width="15%" 
                                            data-type="number" format = "#,###.##" :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>
                                        </DxColumn>   

                                        <DxColumn caption="CARRY OUT" width="50%" data-type="string" :allow-editing="false"
                                            alignment="center" :visible="true">
                                            <DxColumn caption="DATE" width="40%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                                <DxColumn data-field="plnCarryoutDte" caption="PLAN" width="15%" data-type="string" 
                                                         :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="true" />
                                                <DxColumn data-field="actCarryoutDte" caption="ACT" width="15%"  data-type="string"  
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="true" />
                                                <DxColumn data-field="carryDiff" caption="DIFF" width="10%" data-type="string" 
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>
                                            </DxColumn> 
                                            <DxColumn caption="RESULT" width="25%" data-type="string" :allow-editing="false"
                                                alignment="center" :visible="true">
                                                <DxColumn data-field="resultCarryoutQty" caption="Supply" width="15%" data-type="number" format = "#,###" 
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>
                                                <DxColumn data-field="resultNotQty" caption="Not Yet" width="10%" data-type="number" format = "#,###" 
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>                                                   
                                            </DxColumn> 
                                        </DxColumn>   
                                                                    
                                        <DxColumn caption="CUTTING" width="20%" data-type="string" :allow-editing="false" alignment="right" :visible="true">
                                            <DxColumn caption="RESULT" width="20%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                                <DxColumn data-field="cutQty" caption="Q'ty" width="10%" data-type="number" format = "#,###" 
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>
                                                <DxColumn data-field="cutNotQty" caption="Not Yet" width="10%" data-type="number" format = "#,###" 
                                                         :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>                                                   
                                            </DxColumn> 
                                        </DxColumn>
                                       
                                        <DxColumn caption="DELIVERY" width="35%" data-type="string" :allow-editing="false" alignment="right" :visible="true">
                                            <DxColumn caption="RESULT" width="35%" data-type="string" :allow-editing="false" alignment="center" :visible="true">
                                                <DxColumn data-field="dlyQty" caption="Q'ty" width="10%" data-type="number" format = "#,###" 
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>
                                                <DxColumn data-field="dlyDte" caption="DATE" width="15%" data-type="string" 
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="true" />
                                                <DxColumn data-field="dlyNotQty" caption="Not Yet" width="10%" data-type="number" format = "#,###" 
                                                          :allow-editing="false" alignment="center" :visible="true" :allow-header-filtering="false"/>                                                   
                                            </DxColumn> 
                                        </DxColumn>                         
                                        
                                        <DxSummary>
                                            <DxTotalItem column="shipNo" summary-type="count" display-format="SUM" />
                                            <DxTotalItem column="useQty" summary-type="sum" :customize-text="totalFormat" />
                                            <DxTotalItem column="useWgt" summary-type="sum" :customize-text="totalFormatN0" />
                                            <DxTotalItem column="woQty" summary-type="sum" :customize-text="totalFormat" />
                                            <DxTotalItem column="reqQty" summary-type="sum" :customize-text="totalFormat" />
                                            <DxTotalItem column="reqWgt" summary-type="sum" :customize-text="totalFormatN0" />
                                            <DxTotalItem column="resultCarryoutQty" summary-type="sum" :customize-text="totalFormat" />
                                            <DxTotalItem column="resultNotQty" summary-type="sum" :customize-text="totalFormat" />
                                            <DxTotalItem column="cutQty" summary-type="sum" :customize-text="totalFormat" />
                                            <DxTotalItem column="cutNotQty" summary-type="sum" :customize-text="totalFormat" />
                                            <DxTotalItem column="dlyQty" summary-type="sum" :customize-text="totalFormat" />  
                                            <DxTotalItem column="dlyNotQty" summary-type="sum" :customize-text="totalFormat" />
                                        </DxSummary>

                                        <DxPaging :enabled="true" :page-size="14" />
                                    </DxDataGrid>
                                </v-col>
                            </v-row>
                        </v-layout>
                    </template>
                </i-card-vertical>
            </v-col>
        </v-row>       
    </v-container>
</template>

<script>
import ICardVertical from '@/components/common/iCardVertical.vue'
import iCardTop from '@/components/common/iCardTop.vue'
import baseview from '@/components/base/baseview.vue' // 
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import { epmsa014Detail } from '@/api/view/hip/A/epmsa014.js'
import { getShipNoList } from '@/api/view/hip/A/epmsa010_kl'
import { getDateFormat } from '@/utils/common.js'
import DxDateBox from 'devextreme-vue/date-box'
import {DxExport } from 'devextreme-vue/data-grid'
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { getNumComma } from '@/utils/common.js';
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter
} from 'devextreme-vue/data-grid';

export default {
    name: 'epmsa014',
    mixins: [baseview, BaseDataGrid],
    components: {
        ICardVertical,
        'i-card-top': iCardTop,
        DxDateBox ,
        DxExport,
        DxColumn,
        DxHeaderFilter  
    },
    data() {
        return {
            makerCd: this.$store.state.user.makerCd,
            menuTitle: this.$route.meta.title,
            gridMainList: [],
            epmsa014Ref: "epmsa014Ref",
            shipNo: '',
            shipNoList: [],        

            startDate: '',
            endDate: '',

            stDte: '',
            edDte: '',              

            visDiv : true,
            
            expCarry : false,
            expDely  : false,

            division: {
                select: { name: 'By Request Date', cd: '1' },
                items: [
                    { name: 'By PP Start Date', cd: '1' },
                    { name: 'By Request Date', cd: '2' },
                    { name: 'By Ship', cd: '3' }                  
                ]
            },
        }
    },
    computed: {
        gridMainInstance() {
            return this.GetDataGrid(this.epmsa014Ref)
        },
    },
    methods: {

        totalFormat(e) {
            const result = getNumComma(Number(e.value.toFixed(2)), 2)
            return result
        },
        totalFormatN0(e) {
            const result = getNumComma(Number(e.value.toFixed(0)))
            return result
        },
        getStrFormat(date) {
            this.stDte = getDateFormat(date)
            return getDateFormat(date)
        },
        getEndFormat(date) {
            this.edDte = getDateFormat(date)
            return getDateFormat(date)
        },   

        changeDiv() {
            console.log(this.division.select.cd)
            if(this.division.select.cd === '1' || this.division.select.cd === '2' )
                this.visDiv = true;
            else
                this.visDiv = false;
            },
        
        async getShipNoList(){
            try {
                let param = {
                    makerCd: this.makerCd
                    }
                this.openLoading('searching')           

                await getShipNoList(param).then(res => {
                this.shipNoList.push('Select')
                res.list.forEach(e => {
                    this.shipNoList.push(e.shipNo)
                });
                this.shipNo = this.shipNoList[0]           
                })
            } finally {       
                this.endLoading()
            }
        },

        btnRetrieve() {           

            this.doSearchMain()
        },
        async doSearchMain() {

            this.openLoading('searching')
            let params = {
                div: this.division.select.cd,
                shipNo: this.shipNo,
                stDte: this.stDte.replace(/-/g, ""),
                fiDte: this.edDte.replace(/-/g, ""),
                makerCd: this.makerCd,
                expCarry : this.expCarry == true ? 'Y':'N',
                expDely  : this.expDely  == true ? 'Y':'N'
            }
            console.log(params);
            await epmsa014Detail(params).then(res => {
                // res.list.forEach(e => {
                // e.id = e.rnum
                // });
                // this.gridMainList = res.list
                let list = []         
                let cnt = 1;       
                res.list.forEach(e => {
                    list.push(
                        {
                            id: cnt++, reqDte : e.reqDte, shipNo: e.shipNo, block: e.block, cutGrp: e.cutGrp, lotNo: e.lotNo, useQty : e.useQty, useWgt: e.useWgt,
                            woQty: e.woQty,  woWgt: e.woWgt, whDte: e.whDte, whQty: e.whQty, stockQty: e.stockQty, shippDte: e.shippDte, midCutDay: e.midCutDay,
                            reqDte: e.reqDte,  reqQty: e.reqQty, reqWgt: e.reqWgt,
                            plnCarryoutDte : e.plnCarryoutDte, actCarryoutDte : e.actCarryoutDte, carryDiff : e.carryDiff, resultCarryoutQty : e.resultCarryoutQty, 
                            resultNotQty : e.useQty - e.resultCarryoutQty, cutQty: e.cutQty, cutNotQty : e.useQty - e.cutQty, dlyQty: e.dlyQty, dlyDte : e.dlyDte,
                            dlyNotQty : e.cutQty - e.dlyQty, woQty : e.woQty
                        }                       
                    )
                });
                this.gridMainList = list
            }).finally(() => {
                //console.log( this.gridMainList)
                this.endLoading()
            })
            
           
        }, 
        onExporting(e) {
            const workbook = new Workbook();
            const worksheet = workbook.addWorksheet('sheet');

            exportDataGrid({
                component: this.gridMainInstance,
                worksheet,
                topLeftCell: { row: 4, column: 1 },
            }).then((cellRange) => {

            // header
            const titleRow = worksheet.getRow(2);
            titleRow.height = 30;
            worksheet.mergeCells(2, 1, 2, 23);

            titleRow.getCell(1).value = 'Angle Cutting Progress Status (Deahyup VN)';
            titleRow.getCell(1).font = { name: 'Segoe UI Light', size: 22, bold: true };
            titleRow.getCell(1).alignment = { horizontal: 'center' , vertical: 'middle' };

            // condition
            const condRow = worksheet.getRow(3);
            condRow.height = 20;
            worksheet.mergeCells(3, 1, 3, 23);

            let div = this.division.select.cd ;
            let strCond ;
            if(div === '1' || div === '2')
            {
                strCond = this.division.select.name + ' : ' + this.stDte + ' ~ ' + this.edDte;
            }else {
                strCond = this.division.select.name + ' : ' + this.shipNo;
            }

            condRow.getCell(1).value = strCond;
            condRow.getCell(1).font = { name: 'Calibri', size: 12, bold: true };
            condRow.getCell(1).alignment = { horizontal: 'left' , vertical: 'middle' } ;

            const headerRow = worksheet.getRow(4);
            const headerStyle = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'DFE3D5' } }
            const headerBorderStyle = { left: { style: 'thin', fgColor: { argb: 'bfbfbf' } } , right: { style: 'thin', fgColor: { argb: 'bfbfbf' } }, top: {style: 'thin', fgColor: { argb: 'bfbfbf' }}, bottom: {style: 'thin', fgColor: { argb: 'bfbfbf' }} }
            let headerRowLength = headerRow._cells.length        

            for(let i = 4; i <= headerRowLength; i++){
                headerRow.getCell(i).fill = headerStyle
                headerRow.getCell(i).border = headerBorderStyle
                headerRow.getCell(i).alignment = { horizontal: 'center', vertical: 'middle' }
            }
            for(let j = 4; j <= worksheet._rows.length; j++){
                for(let a = 1; a <= worksheet.getRow(j)._cells.length; a++){

                    if (j == 4 || j == 5 || j == 6) {
                        worksheet.getRow(j).getCell(a).fill = headerStyle
                    }

                    worksheet.getRow(j).getCell(a).border = headerBorderStyle
                    
                    // if(worksheet.getColumn(a).dataField == "useQty" || worksheet.getColumn(a).dataField == "woQty") {
                    //     worksheet.getRow(j).getCell(a).format = "#,###"
                    //     worksheet.getRow(j).getCell(a).alignment = { horizontal: 'right' }
                    // }
                }
            }
            }).then(() => {
                workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'AngleCuttingProgress.xlsx');
                });
            });     

            this.gridMainInstance.cancel = true;
        },               
    },
    mounted() {
        var date = new Date();
       
        this.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
        this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this.getShipNoList()
        //this.gridMainInstance.option('defaultPaging', false)
    }
}
</script>

<style scoped>

</style>